import React, { useState, useEffect } from "react";
import { addRecord } from "../../../../firebase/db/fans/crud.tsx";
import { viewRecord } from "../../../../firebase/db/configurations/crud.tsx";
import { useParams } from "react-router-dom";
import { CountryField, StateField, VisitorAPIComponents } from "react-country-state-fields";
import confetti from "canvas-confetti";
import { Audio } from "react-loader-spinner";

interface ConfigType {
	id?: string;
	collection?: string;
	created?: string;
	css_class?: string;
	header_text?: string;
	button_text?: string;
	show_confetti?: Boolean;
	user_id?: string;
}

const LeadFanForm = () => {
	const { id } = useParams();
	const [configData, setConfigData] = useState<ConfigType | null>(null);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [isRegistering, setIsRegistering] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [errorMessage, setErrorMessage] = useState("");
	const [country, setCountry] = useState({ code: "", label: "" }); // the selected country
	const [state, setState] = useState({ code: "", label: "" }); // the selected state
	const visitorApiPrjectId = "YVkgQxHXJYEaFZB75hfy"; // assign your project ID here
	const [themeClass, setThemeClass] = useState("form-body-classic");

	useEffect(() => {
		const fetchDataAndSetState = async () => {
			try {
				console.log("Fetching data...");
				if (id) {
					const fetchedData = await viewRecord(id);
					if (fetchedData !== null) {
						setConfigData(fetchedData);
						setThemeClass(fetchedData.css_class);
						setIsLoading(false);
					} else {
						setErrorMessage("Error loading configurations");
					}
				} else {
					setErrorMessage("Invalid ID");
				}
			} catch (e) {
				setErrorMessage(String(e)); //More informative error message
			} finally {
				setIsRegistering(false);
			}
		};
		fetchDataAndSetState();
	}, [id]);

	const onSubmit = async (e) => {
		e.preventDefault();
		if (!isRegistering) {
			setIsRegistering(true);
			try {
				addRecord({
					created: new Date(),
					modified: new Date(),
					first_name: firstName,
					last_name: lastName,
					email: email,
					country: country.label,
					country_code: country.code,
					state: state.label,
					state_code: state.code,
					user_id: configData.user_id
				}).then(() => {
					if (configData?.show_confetti) {
						showConfetti();
					}
				});
			} catch (e) {}
		}
	};

	function showConfetti() {
		confetti({
			particleCount: 100,
			spread: 70,
			origin: {
				y: 0.6
			}
		});
	}

	if (isLoading) {
		return (
			<Audio
				height="150"
				width="150"
				color="#00c951"
				ariaLabel="audio-loading"
				wrapperStyle={{}}
				wrapperClass="wrapper-class h-screen top-auto w-full justify-center content-center flex self-center place-content-center place-items-center"
				visible={true}
			/>
		);
	} else {
		return (
			<div className={`h-screen ${themeClass}`}>
				<main className="h-screen top-auto w-full justify-center content-center flex self-center place-content-center place-items-center">
					<div className="form-panel w-96 space-y-5 p-4 border rounded-xl">
						<div className="text-center mb-6">
							<div className="mt-2">
								<h2 className="text-xl font-semibold sm:text-2xl">{configData?.header_text}</h2>
							</div>
						</div>
						<form onSubmit={onSubmit} className="space-y-4">
							<div>
								<label className="text-sm font-bold">First Name</label>
								<input
									type="text"
									required
									value={firstName}
									onChange={(e) => {
										setFirstName(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>
							<div>
								<label className="text-sm font-bold">Last Name</label>
								<input
									type="text"
									required
									value={lastName}
									onChange={(e) => {
										setLastName(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>
							<div>
								<label className="text-sm font-bold">Email</label>
								<input
									type="email"
									autoComplete="email"
									required
									value={email}
									onChange={(e) => {
										setEmail(e.target.value);
									}}
									className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
								/>
							</div>

							<VisitorAPIComponents
								projectId={visitorApiPrjectId}
								handleCountryChange={(countryObj) => setCountry(countryObj)}
								handleStateChange={(stateObj) => setState(stateObj)}>
								<div>
									<label className="text-sm font-bold">Country</label>
									<CountryField label=""></CountryField>
								</div>
								<div>
									<label className="text-sm font-bold">State</label>
									<StateField label=""></StateField>
								</div>
							</VisitorAPIComponents>

							{errorMessage && <span className="text-red-600 font-bold">{errorMessage}</span>}

							<button
								onClick={showConfetti}
								type="submit"
								disabled={isRegistering}
								className={`w-full px-4 py-2 text-white font-medium rounded-lg ${
									isRegistering ? "register-button cursor-not-allowed" : "register-button hover:shadow-xl transition duration-300"
								}`}>
								{isRegistering ? "Saving..." : configData?.button_text}
							</button>
						</form>
					</div>
				</main>
				<script src="./assets/vendor/canvas-confetti/dist/confetti.browser.js"></script>
			</div>
		);
	}
};

export { LeadFanForm };
